<template>
  <div class="pot__block">
    <div class="pot__block--inner wbox">
      <div v-show="edit" class="pot__block--edit">
        <textarea-autosize
          placeholder="メモやURLを保存しよう"
          :ref="'postEdit-' + d.id"
          v-model="d.text"
          :min-height="30"
          :max-height="600"
          class="pbox__txt"
          aria-label="add element to the pod"
        />
      </div>
      <div class="pot__block--detail" v-show="edit === false">
        <vue-markdown
        v-if="d.status !== 2"
        :source="d.text"
        :anchorAttributes="{target: '_blank', rel: 'noopener'}"
        >{{d.text}}
        </vue-markdown>
      </div>
      <div class="pot__d__menu--box">
        <div class="pot__block--arch" v-if="d.status === 2">
          アーカイブされています
        </div>
        <ul class="pot__d__menu fx_ctr">
          <li v-show="edit === false" title="edit pot detail" v-on:click="toggleEdit()"><font-awesome-icon icon="edit" /></li>          <li v-show="edit" title="edit pot detail" v-on:click="savePotD({text: d.text})"><font-awesome-icon icon="save" /></li>
          <li v-show="d.status !== 2" title="edit pot detail" v-on:click="savePotD({status: 2})"><font-awesome-icon icon="archive" /></li>
          <li v-show="d.status === 2" title="edit pot detail" v-on:click="savePotD({status: 1})"><font-awesome-icon icon="folder-open" /></li>
          <li title="delete pot detail" v-on:click="deletePotDetail()"><font-awesome-icon icon="trash-alt" /></li>
        </ul>
      </div>
    </div>
    <p class="date pot__date">
      <span v-if="d.created_at !== d.updated_at">{{d.updated_at | formateFileDate}}</span>
      <span v-else>{{d.created_at | formateFileDate}}</span>
    </p>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import { mapActions } from 'vuex';
import dayjs from 'dayjs'

export default {
  props: ['d'],
  data() {
    return {
      edit: false,
      mesPara: {}
    }
  },
  components: {
    VueMarkdown,
  },
  created(){
    this.spToggleOpen(this.$route)
  },
  watch: {
    '$route' (to) {
    this.spToggleOpen(to)
    }
  },
  methods: {
    ...mapActions([
      'toggleSpSlide', 'potDetailsRemove', 'potDetailsUpdate'
    ]),
    deletePotDetail: async function(){
      this.$emit('deletePotDetail', this.d.id);
    },
    savePotD: async function(params){
      this.edit = false;
      this.mesPara = {};
      this.mesPara.icon = 'spinner';
      this.mesPara.message = 'ローカルDBに保存しています';
      this.$emit('setMessage', this.mesPara);

      params.updated_at = dayjs().format('YYYY-MM-DDTHH:mm:ssZ');
      await this.$db.potDetails.update(this.d.id, params)

      await this.$emit('refresh', this.d.potId);

      // potの最終更新も更新する
      await this.$db.pots.update(this.d.potId, {updated_at: dayjs().format('YYYY-MM-DDTHH:mm:ssZ')})
      await this.$emit('refresh', this.d.potId);

      this.mesPara.message = 'ローカルDBに保存しました';
      this.$emit('setMessage', this.mesPara);

      this.mesPara.message = 'クラウドに保存しています...';
      this.$emit('setMessage', this.mesPara);
      // // GDに同期
      await this.gdApiInit();
      await this.gdCheckSignin();
      if(this.isGdSignin){
        await this.setCloudDataset();
        await this.gdUpload();
      }
      this.mesPara = false;
      await this.$emit('setMessage', this.mesPara);
    },
    spToggleOpen(route){
      if(route.name === 'PotDetail'){
          this.toggleSpSlide(true)
      }
    },
    toggleEdit(){
      this.edit = this.edit? false: true;
      if(this.edit){
        // console.log(this.$refs);
        // console.log(did);
        this.$nextTick(() => {
          this.$refs['postEdit-' + this.d.id].$el.focus()
        })
        this.mesPara = {};
        this.mesPara.message = '編集モード';
        this.mesPara.icon = 'edit';
        this.$emit('setMessage', this.mesPara);
      }
    }
  }
}
</script>
<style lang="scss">
.pot__d__menu--box{
  justify-content: flex-end;
  align-items: center;
  display: flex;
  .pot__d__menu{
    display: inline-flex;
    justify-content: flex-end;
    list-style: none;
    font-size: .9rem;
    color: #546370;
    margin: 0 4px;
    padding: 0 4px 4px;
    li{
      margin: 0 4px;
      padding: 4px;
      cursor: pointer;
      &:hover{
        color: #999;
      }
    }
  }

}
</style>
